<template>
    <div class="el-table-row-container dw-10">
        <ath-table-row :style="{'cursor': hasChildren ? 'pointer' : ''}"
            :data="data"
            :columns="columns"
            :pubkey="pubkey"
            :class="[!hasChildren ? 'no-children' : '', cname]"
            :expanded="expanded"
            :index="idx"
            :allowRedirect="allowRedirect"
            @onDropdownItemClicked="onDropdownItemClicked"
            @onCheckboxChange="onCheckboxChange"
            @onButtonClicked="onButtonClicked"
            @click="onClick(data)"
            @clickColumn="onClickColumn(...arguments, data)"
            @redirect="onRedirect(data)" />
        <template v-if="expanded">
            <ath-table-row v-for="(obj, index) in data.children"
                :key="obj.uid"
                :data="obj"
                :columns="columns"
                :index="idx"
                :pubkey="pubkey"
                :allowRedirect="allowRedirect"
                :class="[index === data.children.length - 1 ? 'last-row' : '', cname]"
                @onDropdownItemClicked="onDropdownItemClicked"
                @onCheckboxChange="onCheckboxChange"
                @onButtonClicked="onButtonClicked"
                @click="onClick(obj, true)"
                @clickColumn="onClickColumn(...arguments, obj, true)"
                @redirect="onRedirect(obj)" />
        </template>
    </div>
</template>

<script>
import { isNeArray } from '@aretheyhappy/utils';
import AthTableRow from './TableRow.vue';

export default {
    name: 'mead-table-row-container',
    components: {
        AthTableRow,
    },
    props: {
        /**
         * Public key used to publish collapse/expand change events on the global Flash bus,
         * identifying this row container to any listening parent.
         */
        pubkey        : {type: String, default: () => ''},
        /**
         * The row's data record, passed through to the underlying TableRow (and, when expanded,
         * used to render one TableRow per child in data.children).
         */
        data          : {type: Object, default: () => {}},
        /**
         * The column definitions passed through to each rendered TableRow.
         */
        columns       : {type: Array, default: () => []},
        /**
         * Additional CSS class(es) applied to each rendered TableRow (both the parent row and
         * any expanded child rows).
         */
        cname         : {type: Array, default: () => []},
        /**
         * The row's position in the table, passed through to each rendered TableRow as its index.
         */
        idx           : {type: Number, default: 0},
        /**
         * Whether to show the trailing redirect chevron on the rendered TableRow(s).
         */
        allowRedirect : {type: Boolean, default: () => false},
    },
    data () {
        return {
            show_children: this.data.config.start_expanded,
        };
    },
    methods: {
        toggleChildren: function () {
            if (!this.hasChildren) return;
            this.show_children = !this.show_children;
            MeadCommon.Flash.publish(`${this.pubkey}:collapse_change`, {
                id   : this.data.uid,
                value: this.show_children,
            });
        },
        onDropdownItemClicked: function (data) {
            this.$emit('onDropdownItemClicked', data);
        },
        onCheckboxChange: function (data) {
            this.$emit('onCheckboxChange', data);
        },
        onButtonClicked: function (data) {
            this.$emit('onButtonClicked', data);
        },
        onClick: function (data, is_children = false) {
            if (this.hasChildren && !is_children) {
                this.toggleChildren();
            } else {
                if (!data.config.clickable) return;

                this.$emit('click', data);
            }
        },
        onClickColumn: function (column, data, is_children = false) {
            if (this.hasChildren && !is_children || !data.config.clickable) return;

            this.$emit('clickColumn', data, column);
        },
        onRedirect: function (data) {
            if (!data.config.clickable) return;

            this.$emit('redirect', data);
        }
    },
    computed: {
        hasChildren: function () {
            return isNeArray(this.data.children);
        },
        expanded: function () {
            return this.show_children && this.hasChildren;
        },
    },
};
</script>